import { Controller } from '@hotwired/stimulus'
import Cookies from 'js-cookie'
import { shrinkHideElement } from 'utils/toggle_element_visibility'
export default class extends Controller {
  initialize() {
    if (this.element.dataset.autoDismissAfter) {
      const autoDismissAfter = parseInt(this.element.dataset.autoDismissAfter)
      setTimeout(this.dismiss.bind(this), autoDismissAfter)
    }
  }

  dismiss(_event) {
    const cookie = this.element.dataset.dismissCookie
    const expiration = parseInt(this.element.dataset.dismissExpiresInDays)

    shrinkHideElement(this.element)
    Cookies.set(cookie, "true", { expires: expiration })
  }
}
